/* Product page: thumbnail gallery, quantity stepper, variant selection.
   Variant data is embedded as JSON by sections/main-product.liquid. */
(function () {
  function initGallery(root) {
    var main = root.querySelector('[data-gallery-main]');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-gallery-thumb]'));
    if (!main || thumbs.length === 0) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        main.src = thumb.dataset.full;
        main.srcset = '';
        main.alt = thumb.dataset.alt || '';
        thumbs.forEach(function (t) { t.classList.toggle('is-active', t === thumb); });
      });
    });
  }

  function initQuantity(root) {
    root.querySelectorAll('[data-qty]').forEach(function (wrap) {
      var input = wrap.querySelector('input');
      wrap.querySelectorAll('[data-qty-step]').forEach(function (button) {
        button.addEventListener('click', function () {
          var step = parseInt(button.dataset.qtyStep, 10);
          var next = (parseInt(input.value, 10) || 1) + step;
          input.value = Math.max(1, next);
        });
      });
    });
  }

  function initVariants(root) {
    var dataEl = root.querySelector('[data-variant-json]');
    var idInput = root.querySelector('[data-variant-id]');
    if (!dataEl || !idInput) return;

    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var priceEl = root.querySelector('[data-variant-price]');
    var button = root.querySelector('[data-add-button]');
    var inputs = Array.prototype.slice.call(root.querySelectorAll('[data-option-index]'));
    if (inputs.length === 0) return;

    function selected() {
      var chosen = [];
      inputs.forEach(function (input) {
        if (input.checked) chosen[parseInt(input.dataset.optionIndex, 10)] = input.value;
      });
      return chosen;
    }

    function update() {
      var chosen = selected();
      var match = variants.find(function (variant) {
        return variant.options.every(function (option, i) { return option === chosen[i]; });
      });

      if (!match) {
        if (button) {
          button.disabled = true;
          button.textContent = 'הצירוף אינו זמין';
        }
        return;
      }

      idInput.value = match.id;
      if (priceEl) priceEl.innerHTML = match.price_html;
      if (button) {
        button.disabled = !match.available;
        button.textContent = match.available ? 'הוספה לסל' : 'אזל מהמלאי';
        button.dataset.labelDefault = button.textContent;
      }

      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        history.replaceState({}, '', url.toString());
      }
    }

    inputs.forEach(function (input) { input.addEventListener('change', update); });
  }

  function init(root) {
    initGallery(root);
    initQuantity(root);
    initVariants(root);
  }

  document.querySelectorAll('[data-product-root]').forEach(init);

  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-product-root]').forEach(init);
  });
})();
